import { Inject, Injectable } from '@angular/core';
import { APP_DI_SETTINGS, IParameters } from './parameters.interface';

@Injectable()
export class SettingsService {

    /**
     * Service class Constructor
     */
    constructor(@Inject(APP_DI_SETTINGS) private settings: IParameters) {}

    /**
     * Return specific value by key
     */
    public get(key?: string): any {
        const settings = this.settings;
        if ( key ) {
            return settings.hasOwnProperty(key) ? settings[key] : null;
        } else {
            return null;
        }

    }

    /**
     * Return a copy of the private _settings attribute which holds all
     * the Key:Value pairs
     */
    public get params(): IParameters {
        return Object.assign({}, this.settings);
    }

}
